import { type EnrichedAdInputField, getAt } from '@finn-no/mobility-item-insertion-shared';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { getHuckConfig } from '../utils/getHuckConfig.js';

export const useRegistrationPriceHandler = () => {
  const config = getHuckConfig();
  const { watch, setValue } = useFormContext();

  const registrationPriceField = getAt<EnrichedAdInputField>(config.adInputLookup, 'price.children.registration_price');

  const registrationExemption = watch('price.registration_tax_exemption');
  const registrationPrice = watch('price.registration_price');

  const userHasSetExemptionToTrue = registrationExemption === 'YES' || registrationExemption === 1;

  useEffect(() => {
    if (registrationPriceField?.mandatory && userHasSetExemptionToTrue && !registrationPrice) {
      setValue('price.registration_price', 0);
    }
  }, [registrationPriceField?.mandatory, registrationExemption, registrationPrice, setValue]);

  return null;
};
